import React, { useState } from 'react';
import { useDisclosure } from '@podiumhq/design-system';

import CreditCardFields from 'components/CreditCardDetails/CreditCardFields';
import { useCreditCardContext } from 'contexts/CreditCardDetailsContextProvider';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';

import { useSetUpPurchaseIntent } from '../../hooks';
import { SelectPlanCheckoutPaymentFieldsWrapper } from '../../styles';

import PaymentDetails from '../PaymentDetails';

import { EditModalWrapper } from './modals';
import { ErrorNotification } from '../ErrorNotification';

export const PaymentSummary = () => {
  const { resetCreditCardErrors } = useCreditCardContext() || {};
  const { isOpen, onOpen, onClose } = useDisclosure();

  const trackEvent = useTrackAmplitudeEvent();
  const { error, handleSetUpIntentData } = useSetUpPurchaseIntent(trackEvent);

  const [isUpdating, setIsUpdating] = useState(false);

  const openModal = () => {
    resetCreditCardErrors();
    onOpen();
  };

  const updatePaymentInfo = () => {
    setIsUpdating(true);
    handleSetUpIntentData()
      .then((isSuccessful) => {
        setIsUpdating(false);

        if (isSuccessful) {
          onClose();
        }
      })
      .catch((errorInHandle) => {
        console.log({ errorInHandle });
        setIsUpdating(false);
      });
  };

  return (
    <>
      <PaymentDetails mb="24px" openModal={openModal} />

      <EditModalWrapper
        handleSave={updatePaymentInfo}
        headerTitle="Edit card information."
        isOpen={isOpen}
        isSaving={isUpdating}
        onClose={onClose}
      >
        <SelectPlanCheckoutPaymentFieldsWrapper mb="-24px">
          <CreditCardFields trackOnBlurPath="selectPlanCheckout.paymentInfo" />
        </SelectPlanCheckoutPaymentFieldsWrapper>

        <ErrorNotification errorMessage={error} mt="24px" />
      </EditModalWrapper>
    </>
  );
};
